export default {
  blik__title: 'Complete your payment with BLIK transfer',
  blik__intro: 'To finish the payment, make a transfer to the phone number below.',

  blik__phone_label: 'Transfer to this phone number',
  blik__full_name_label: 'Recipient first and last name',
  blik__amount_label: 'Amount to transfer',
  blik__time_remaining: 'Time remaining',

  blik__step_1: 'Open your banking app (or online banking).',
  blik__step_2: 'Choose transfer to phone number (BLIK P2P).',
  blik__step_3: 'Enter the phone number: <b>{customer_phone}</b>',
  blik__step_4: 'Verify that the recipient\'s first and last name match. If this field is not mandatory — skip this step.',
  blik__step_5: 'Enter the amount: <b>{amount} {currency}</b>',
  blik__step_6: 'Confirm the transfer and return to this page.',

  blik__after_transfer:
    'After the transfer is completed, the payment status will update automatically. This may take a short moment.',

  blik__info_banner: 'Complete the transfer in your banking app to confirm the payment.',

  blik__btn_confirm: 'I have made the transfer',
  blik__btn_cancel: 'Cancel and return',

  blik__note_1: 'If you do not complete the transfer, the payment will not be confirmed.',
  blik__note_2: 'If the instruction expires (if shown), create a new payment and try again.',
};
